import React, {PropsWithChildren, useImperativeHandle, useRef} from 'react';
import 'react-datepicker/dist/react-datepicker.css'
import 'component/Datepicker.css'
import {deAT} from 'date-fns/locale'
import ReactDatePicker, {DatePickerProps, registerLocale, setDefaultLocale} from "react-datepicker"
import {Portal, PortalProps} from 'react-portal'

registerLocale('deAT', deAT)
setDefaultLocale('deAT')

function PopperContainer({children, ...props}: PropsWithChildren<PortalProps>) {
	const node = document.body
	return children && <Portal node={node} {...props}>{children}</Portal> || null
}

/**
	use the following props for basic usage
	selected={selected}
	disabled={disabled}
	onChange={(date: Date) => set(moment(date))}
	onChangeRaw={(event: React.FocusEvent<HTMLInputElement>) => set(event.target.value)}
 */
export const DatePicker = React.forwardRef<ReactDatePicker | null, DatePickerProps>((props, ref) => {
	const innerRef = useRef<ReactDatePicker | null>(null)
	useImperativeHandle<ReactDatePicker | null, ReactDatePicker | null>(ref, () => innerRef.current)
	const {isClearable = true} = props
	return <ReactDatePicker
		ref={innerRef}
		preventOpenOnFocus
		onKeyDown={(evt: React.KeyboardEvent<HTMLDivElement>) => {
			const r = innerRef.current
			if (!r) return;
			if (evt.key === 'Tab') {
				// fixes: tab out of datepicker does not close calendar
				if (r.state.open) r.setOpen(false, false)
			} else if (evt.key === 'Enter') {
				// fixes enter results in invisible focus, but still focussed
				r.setOpen(!r.state.open, false)
				// enter should keep focus on this field
				setTimeout(() => r.setFocus(), 1)
			}
		}}
		onFocus={(evt: React.FocusEvent<HTMLInputElement>) => evt.target.select()}
		dateFormat={'yyyy-MM-dd'}
		peekNextMonth={false}
		strictParsing
		// disabledKeyboardNavigation
		locale={'deAT'}
		popperContainer={PopperContainer}
		{...props}
		isClearable={isClearable}
	/>
})